import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs';
import { ProjectActions } from './project.actions';
import { ProjectService } from '@/core/services/project.service';
import { ProjectApiModel } from '@/core/models/api/project-api-model.model';

@Injectable()
export class ProjectEffects {
    actions$ = inject(Actions);
    projectService = inject(ProjectService);

    _loadProjects = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectActions.loadProjects),
            exhaustMap(() => {
                return this.projectService.getAll().pipe(
                    map((response: any) => {
                        const projects = response as ProjectApiModel[];
                        return ProjectActions.loadProjectsSuccess({ projects });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of(ProjectActions.loadProjectsFail({ error: error.message }));
                    })
                );
            })
        );
    });

    _loadProjectById = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectActions.loadProjectById),
            switchMap((action) => {
                return this.projectService.getById(action.projectId).pipe(
                    map((project: ProjectApiModel) => {
                        return ProjectActions.loadProjectByIdSuccess({ project });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of(ProjectActions.loadProjectByIdFail({ error: error.message }));
                    })
                );
            })
        );
    });
}
